export const TRIAL_BALANCE_REPORT = `report/trial_balance`;
